<template>
  <div>
    <nav-title :color="false" :title="'Quick Tips'" />

    <section class="container">
      <h5 class="text-center pt-3 m-0">
        {{ $route.query.name }}
      </h5>
      <p class="p-3 mx-lg-5">
        Learn more about specific strategies for each skill and set goals around
        these skills.
      </p>
      <skill-list :options="getSkillTipsList" />
    </section>
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import skillList from "@/components/help/skillList.vue";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  components: {
    navTitle,
    skillList
  },
  computed: {
    ...mapGetters("help", ["getSkillTipsList"])
  },
  beforeRouteEnter(to, from, next) {
    let tip = to.query.tip;
    Promise.all([store.dispatch("help/FetchSkillsTips", tip)]).then(() => {
      next();
    });
  }
};
</script>
